








































import { Component, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';
import bus from '@/core/bus';
import { BusConstants, ModalConstants } from '@/core/constants';
import { RealmLogType } from '@/types/apiServerContract';

@Component
export default class UpdateRealmSecurity extends Vue {
	permissions: string[] = [ApiPermissions.Realm.UploadLua];
	loading = false;
	luaFiles: string[] = [];
    selectedLuaFile: string = '';

    async deleteLUAFile() {
        if (!this.selectedLuaFile) return;

        this.loading = true;

        try {
            const result = await RealmApi.DeleteLUAFile({
                fileName: this.selectedLuaFile
            });

            this.selectedLuaFile = '';

            if (result) {
                this.getLUAFiles();

                this.$bvToast.toast('File deleted successfully', {
                    variant: 'success',
                    title: 'Success'
                });
            }
        } finally {
            this.loading = false;
        }
    }

    async getLUAFiles() {
	    // const result = await RealmApi.GetLUAFiles();
	    // this.luaFiles = result.directories;
    }

    created() {
	    this.getLUAFiles();
	    bus.on(BusConstants.SelectedRealmChanged, this.getLUAFiles);
    }

    beforeDestroy() {
	    bus.off(BusConstants.SelectedRealmChanged, this.getLUAFiles);
    }

    showHistory() {
	    bus.emit(BusConstants.RealmLogHistoryType, RealmLogType.LUADelete);
	    this.$bvModal.show(ModalConstants.RealmLogHistoryWindow);
    }
}
